import React from 'react';
import { Header } from '../components/Header';
import { HeroCarousel } from '../components/HeroCarousel';
import { Products } from '../components/Products';
import { About } from '../components/About';
import { Features } from '../components/Features';
import { Contact } from '../components/Contact';
import { WhatsAppButton } from '../components/WhatsAppButton';

export const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroCarousel />
      <Products />
      <About />
      <Features />
      <Contact />
      <WhatsAppButton />
      
      {/* Footer */}
      <footer className="bg-slate-900 text-white py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-slate-400">
              © 2024 Bahtera Lima Utama. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};
